import { useEffect } from "react";

export default function StripeReturn() {
  useEffect(() => {
    // redirect back into the OhBet app
    window.location.href = "ohbet://stripe-return";
  }, []);

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      flexDirection: "column",
      fontFamily: "sans-serif"
    }}>
      <h2>Returning to OhBet...</h2>
      <p>If the app does not open automatically, tap below.</p>

      <a
        href="ohbet://stripe-return"
        style={{
          marginTop: 20,
          padding: "12px 20px",
          background: "#000",
          color: "#fff",
          borderRadius: 8,
          textDecoration: "none"
        }}
      >
        Open OhBet
      </a>
    </div>
  );
}